export default (fn) => (e) => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  if (fn) {
    fn();
  }
};
